export default __webpack_public_path__ + "static/media/14.41f92155.png";